import * as React from 'react';

import { ModalDialog } from 'catering/components/Modals';
import { callAll } from 'catering/helpers';

const NotificationModalContext = React.createContext(null);
NotificationModalContext.displayName = 'NotificationModalContext';

function NotificationModalProvider(props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [content, setContent] = React.useState(null);
  return (
    <NotificationModalContext.Provider
      value={{ isOpen, setIsOpen, content, setContent }}
      {...props}
    />
  );
}

function useNotificationModalContext() {
  const context = React.useContext(NotificationModalContext);
  if (!context) {
    throw new Error(
      `useNotificationsModalContext must be used within a NotificationModalContext`
    );
  }
  return context;
}

function NotificationModalDismissButton({ children: child }) {
  const { setIsOpen } = useNotificationModalContext();
  return React.cloneElement(child, {
    onClick: callAll(() => setIsOpen(false), child.props.onClick)
  });
}

function NotificationModalRoot() {
  const { isOpen, setIsOpen, content } = useNotificationModalContext();
  return (
    <ModalDialog open={isOpen} onClose={() => setIsOpen(false)}>
      {content}
    </ModalDialog>
  );
}

export {
  NotificationModalDismissButton,
  NotificationModalProvider,
  NotificationModalRoot,
  useNotificationModalContext
};
